<template>
  <div class="row">
    <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">    
      <div class="card border border-dark">
        <div class="pt-3" :class="[$style.container, $style.container__box]">
          <div class="bg-secondary" :class="$style.status"></div>
          <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
            <div class="mr-auto">
              <h5 class="font-weight-bold">TOTAL: {{ moves.cajas.total }}</h5>
            </div>
            <div class="ml-1 text-secondary">
              <img src="resources/images/box.svg" width="50px"/>
            </div>
          </div>
          <div :class="$style.title" class="text-white font-size-18 font-weight-bold text-center">CAJAS</div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">    
      <div class="card border border-dark">
        <div class="pt-3" :class="[$style.container, $style.container__folder]">
          <div class="bg-secondary" :class="$style.status"></div>
          <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
            <div class="mr-auto">
              <h5 class="font-weight-bold">TOTAL: {{ moves.carpetas.total }}</h5>
            </div>
            <div class="ml-1 text-secondary">
              <img src="resources/images/folder.svg" width="50px"/>
            </div>
          </div>
          <div :class="$style.title" class="text-white font-size-18 font-weight-bold text-center">CARPETAS</div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">    
      <div class="card border border-dark">
        <div class="pt-3" :class="[$style.container, $style.container__box_up]">
          <div class="bg-secondary" :class="$style.status"></div>
          <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
            <div class="mr-auto">
              <h5 class="font-weight-bold">TOTAL: {{ moves.ingresos.total }}</h5>
            </div>
            <div class="ml-1 text-secondary">
              <img src="resources/images/box-up.svg" width="60px"/>
            </div>
          </div>
          <div :class="$style.title" class="text-white font-size-18 font-weight-bold text-center">INGRESOS</div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">    
      <div class="card border border-dark">
        <div class="pt-3" :class="[$style.container, $style.container__box_return]">
          <div class="bg-secondary" :class="$style.status"></div>
          <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
            <div class="mr-auto">
              <h5 class="font-weight-bold">TOTAL: {{ moves.salidas.total }}</h5>
            </div>
            <div class="ml-1 text-secondary">
              <img src="resources/images/box-return.svg" width="60px"/>
            </div>
          </div>
          <div :class="$style.title" class="text-white font-size-18 font-weight-bold text-center">SALIDAS</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    moves: Object
  },

  name: 'ListPanel',
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
